// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation-module--nav--2Kquj","link":"navigation-module--link--38Wd0","dimOvercast":"navigation-module--dimOvercast--3iGHq"};